module.exports = __webpack_public_path__ + "static/assets/caa086bfcb71bac127349f7087d7c349.svg";